import appSettings from 'wanderu-config';
import {
    actionDuckUtils,
} from 'wanderu-ducks-utils';
import Logger from 'wanderu-logger';
import { SnowplowService } from 'wanderu-service-analytics';

import { actions as carrierContactActions } from '../../appstate/carrierContact';
import { getCarrierContact } from '../../services/seoService';
import sliceNamespace from '../../types';

const namespace = 'ACTIONS/FETCH_CARRIER_CONTACT';
const {
    actions,
    reducer,
    selectors,
} = actionDuckUtils.buildBaseDuck(namespace, sliceNamespace);

const logger = Logger.getLogger('fetchCarrierContact');

function fetchCarrierContact(locale) {
    return async function(dispatch) {
        let error = null;

        dispatch(actions.startWork(locale));

        try {
            const { result } = await getCarrierContact({ locale });

            dispatch(carrierContactActions.setCarrierContactContent(result, locale));
            return result;
        } catch (ex) {
            const domainUserInfo = appSettings.env.isClient
                ? SnowplowService.getDomainUserInfo()
                : {};

            logger.error('fetch', ex, {
                snowplowIds: {
                    networkUserId: SnowplowService.getNetworkUserId(),
                    ...domainUserInfo,
                },
            });
            error = {
                code: ex.code,
                message: 'set carrier contact failed',
                name: ex.code,
                status: ex.responseBody.error.status,
            };
        } finally {
            dispatch(actions.endWork(locale, undefined, error));
        }
    };
}

const fetchCarrierContactAction = {
    fetchCarrierContact,
    ...selectors,
};

export {
    fetchCarrierContactAction,
    namespace,
};

export default {
    [namespace]: reducer,
};
